"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFontAwesomeIcon = void 0;
var react_1 = __importDefault(require("react"));
var style_utils_1 = require("@nef/style-utils");
var styled_components_1 = __importStar(require("styled-components"));
var innerFunction = react_1.default.forwardRef(function (_a, ref) {
    var light = _a.light, props = __rest(_a, ["light"]);
    return react_1.default.createElement("i", __assign({ ref: ref }, props));
});
innerFunction.displayName = "innerFunction";
exports.StyledFontAwesomeIcon = styled_components_1.default(innerFunction)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1em;\n  outline: none;\n  text-align: center;\n  vertical-align: middle;\n\n  ", ";\n"], ["\n  color: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1em;\n  outline: none;\n  text-align: center;\n  vertical-align: middle;\n\n  ",
    ";\n"])), style_utils_1.getColor("gray", 900), function (props) {
    return props.light && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), style_utils_1.colorSelector(props, "gray", 300));
});
var FontAwesomeIcon = react_1.default.forwardRef(function (_a, ref) {
    var iconSetClassName = _a.iconSetClassName, iconClassName = _a.iconClassName, className = _a.className, props = __rest(_a, ["iconSetClassName", "iconClassName", "className"]);
    return (react_1.default.createElement(exports.StyledFontAwesomeIcon, __assign({}, props, { className: style_utils_1.classNames([iconSetClassName, iconClassName], className), ref: ref })));
});
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.defaultProps = {
    iconSetClassName: "fas"
};
exports.default = FontAwesomeIcon;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map